module.exports = __webpack_public_path__ + "static/media/mint.cff5a80b.jpg";